import React, { useState } from 'react'
import { Plus } from 'lucide-react'
import PageIntro from '../../components/PageIntro/PageIntro'
import ContentCreatorTable from '../../components/Table/ContentCreatorsTable'
import RegisterCreator from '../../components/Modal/RegisterCreator'

const ContentCreatorPage = () => {
  const [showCreator, setShowCreator] = useState(false)

  return (
    <div className='mx-auto max-w-7xl space-y-6'>
      <PageIntro
        title={'Micro-Content Creator'}
        actions={
          <button
            type='button'
            onClick={() => setShowCreator(!showCreator)}
            className='inline-flex h-9 items-center rounded-lg bg-brand-orange px-4 text-sm font-semibold text-white transition-colors hover:bg-brand-orange-600'
          >
            <Plus className='mr-1.5 h-4 w-4' />
            Register Creator
          </button>
        }
      />

      {showCreator && <RegisterCreator close={() => setShowCreator(false)} />}

      <ContentCreatorTable />
    </div>
  )
}

export default ContentCreatorPage
